export enum Collections {
  USERS = 'users',
  CLIENTS = 'clients',
  CLIENTS_PRIVATE = 'clients_private',
  COURSE_ADMINISTRATORS = 'course_administrators',
  ENROLLMENT_USERS = 'enrollment_users',
  ENROLLMENTS = 'enrollments',
  ENROLLMENTS_PUBLIC = 'enrollments_public',
  EVENTS = 'events',
  ACTIVITIES = 'activities',
  APP_LOGS = 'app_logs',
  /** Temporary: portal login perf measurement (remove after analysis window). */
  PORTAL_LOGIN_PERF_LOGS = 'portal_login_perf_logs',
  USER_LOGS = 'user_logs',
  ADMIN_DOCS = 'admin_docs',
  SWISH_PAYMENT_INTENT_STATUS = 'swish_payment_intent_status',
  SWISH_CONFIG = 'swish_config',
  STRIPE_CONFIG = 'stripe_config',
  STRIPE_PAYMENT_INTENT_STATUS = 'stripe_payment_intent_status',
  EMAIL_TEMPLATES = 'email_templates',
  MAILING = 'mailing',
  URL_SHORT = 'url_short',
  SUBEVENT_ACTIVITIES = 'subevent_activities',
  VIPPS_PAYMENT_STATUS = 'vipps_payment_status',
  VIPPS_CONFIG = 'vipps_config',
  FRITIDSKORTET_CONFIG = 'fritidskortet_config',
  EARLY_BIRD_BOOKINGS = 'early_bird_bookings',
  SESSIONS = 'sessions',
  PAYMENT_TRANSACTIONS = 'payment_transactions',
  FORTNOX_CONFIG = 'fortnox_config',
  SEB_CONFIG = 'seb_config',
  SEB_CREDENTIALS = 'seb_credentials',
  CLIENTS_HOST = 'clients_host',
  DROPIN_TICKETS_PUBLIC = 'dropin_tickets_public',
  SMS_CONFIG = 'sms_config',
  EPASSI_CONFIG = 'epassi_config',
  EPASSI_PAYMENT_STATUS = 'epassi_payment_status',
  SYSTEM_CONFIG = 'system_config',
  WALK_IN_SESSIONS = 'walk_in_sessions',
  SENDGRID_BOUNCE_USERS = 'sendgrid_bounce_users',
  /** One-time GTM booking_paid beacon payloads. Server-written; HTTP beacon consumes and deletes. */
  GTM_BOOKING_PAID_BEACONS = 'gtm_booking_paid_beacons',
  /** Super Admin portal view-as tickets. Server Admin SDK only — no client rules. */
  PORTAL_VIEW_AS_SESSIONS = 'portal_view_as_sessions'
}

export enum Subcollections {
  /** Per-recipient rows for marketing mailings (`mailing/{id}/deliveries/{id}`). */
  MAILING_DELIVERIES = 'deliveries',
  COMMUNICATION_LOG = 'communication_log',
  FREE_DROPIN_GRANTS = 'free_dropin_grants',
  FREE_DROPIN_NOTIFICATIONS = 'free_dropin_notifications',
  FREE_DROPIN_QUALIFICATIONS = 'free_dropin_qualifications',
  BOOKINGS = 'bookings',
  DROPIN_TICKETS = 'dropin_tickets',
  DISCOUNT_CODES = 'discount_codes',
  BANK_TRANSACTIONS = 'bank_transactions',
  SEB_BANK_TRANSACTIONS = 'seb_bank_transactions',
  PRIVATE_LESSON_ORDERS = 'private_lesson_orders',
  PRIVATE_LESSONS = 'private_lessons',
  PRIVATE_LESSON_BLOCKS = 'private_lesson_blocks',
  ROOM_MANAGEMENT = 'room_management',
  CLIENT_LOGS = 'client_logs',
  /** Control Center manual print slips (`clients/{clientId}/reception_print_logs/{id}`). Append-only. */
  RECEPTION_PRINT_LOGS = 'reception_print_logs',
  /** Live Checkin App scan mirror (`clients/{clientId}/reception_live/lastScan`). Last-write-wins. */
  RECEPTION_LIVE = 'reception_live',
  ACTIVITY_LOGS = 'activity_logs',
  /** Per-enrollment admin change log (`clients/{clientId}/enrollments/{id}/enrollment_logs/{id}`). Server-written. */
  ENROLLMENT_LOGS = 'enrollment_logs',
  CLIENT_EMAIL_FLOW_TEMPLATES = 'client_email_flow_templates',
  CLIENT_EMAIL_TEMPLATE_SENDS = 'client_email_template_sends',
  /** Cached customer KPI metrics (`clients/{clientId}/customer_metrics/current`). Server-written only. */
  CUSTOMER_METRICS = 'customer_metrics'
}
